import Konva from 'konva'
import { normalizeTextSize } from '~/components/Preview/AssetsOverlay/lib'
import { formatRBGColor } from '~/Util'

export const createText = (asset, { boundingRect,
  externalTextRef, onlyAttrs = false, isTransform } = {}) => {
  const { settings, text: textString, isInitialized } = asset
  const {
    align, background: backgroundColor, color, font, fontSize, fontStyle,
    outlineColor, outlineWidth, shadowBlur, shadowColor,
    disableShadow, disableOutline, shadowOffset = { x: 2, y: 2 }, size,
  } = settings

  const { width } = size

  let textParams = {
    text: externalTextRef?.attrs.text ?? textString,
    fontFamily: font,
    fontSize: fontSize * 3,
    fontStyle: `${fontStyle.bold ? 'bold' : ''} ${fontStyle.italic ? 'italic' : ''}`,
    align,
    verticalAlign: 'middle',
    fill: formatRBGColor(color),
    stroke: formatRBGColor(outlineColor),
    strokeWidth: !disableOutline ? outlineWidth : 0,
    fillAfterStrokeEnabled: true,
    wrap: 'word',
    key: 'text',
  }

  if (isInitialized) {
    textParams = { ...textParams, width }
  }

  const text = new Konva.Text(textParams)

  // text.scale(scale ?? { x: 1, y: 1 })
  if (text.getWidth() === 0) {
    text.setWidth(1)
  }
  if (externalTextRef) {
    text.textArr = externalTextRef.textArr
  }

  const shadowStrokeWorkaround = text.clone({
    fill: null,
    stroke: formatRBGColor(outlineColor),
    strokeWidth: !disableOutline ? outlineWidth : 0,
    shadowColor: formatRBGColor({ ...shadowColor, a: 1 }),
    shadowOffset,
    shadowBlur: (fontSize / __CFG__.MAX_FONT_SIZE) * shadowBlur,
    shadowEnabled: !disableShadow,
    wrap: 'word',
    key: 'clone',
  })

  const shadowStrokeWorkaroundRect = shadowStrokeWorkaround.getClientRect()
  const textClientRect = text.getClientRect()
  const skipStrokeWorkaroundRect = shadowStrokeWorkaround.getClientRect({ skipStroke: true })
  const measuredHeight = textClientRect.height - 2 * skipStrokeWorkaroundRect.y
  const measuredWidth = textClientRect.width - 2 * skipStrokeWorkaroundRect.x
  const normalizedSize = normalizeTextSize({
    isMeasured: true,
    textSize: { width: measuredWidth, height: measuredHeight },
    boundingRect,
  })

  const group = new Konva.Group({
    ...normalizedSize,
    y: -shadowStrokeWorkaroundRect.y,
    x: -shadowStrokeWorkaroundRect.x,
    key: 'group',
  })

  const background = new Konva.Rect({
    ...normalizedSize,
    y: shadowStrokeWorkaroundRect.y,
    x: shadowStrokeWorkaroundRect.x,
    fill: formatRBGColor(backgroundColor),
    key: 'background',
  })

  group.add(background)

  if (isTransform) {
    shadowStrokeWorkaround.attrs.y = shadowStrokeWorkaroundRect.y - shadowOffset.y
    shadowStrokeWorkaround.attrs.x = shadowStrokeWorkaroundRect.x
    shadowStrokeWorkaround.attrs.opacity = shadowColor.a
    group.add(shadowStrokeWorkaround)
  } else {
    const image = new Konva.Image({
      ...normalizedSize,
      image: shadowStrokeWorkaround.toCanvas(),
      opacity: shadowColor.a,
      y: shadowStrokeWorkaroundRect.y - shadowOffset.y,
      x: shadowStrokeWorkaroundRect.x,
      key: 'image',
    })
    group.add(image)
  }

  group.add(text)

  if (fontStyle.underline) {
    const underline = new Konva.Rect({
      width: normalizedSize.width,
      height: normalizedSize.height * 0.05,
      fill: formatRBGColor(color),
      position: { y: normalizedSize.height },
      strokeWidth: outlineWidth,
      stroke: formatRBGColor(outlineWidth ? outlineColor : color),
      key: 'rect',
    })
    group.add(underline)
  }

  if (onlyAttrs) {
    const attrs = JSON.parse(JSON.stringify(group.attrs))
    group.destroyChildren()
    group.destroy()
    shadowStrokeWorkaround.destroy()
    return { attrs }
  }

  return group
}
